import DepartmentTable from "./DepartmentTable";

export default DepartmentTable;
